import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-forbidden-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.scss'],
  imports: [MatIconModule, TranslocoDirective]
})
export class ForbiddenPageComponent {
  title = input('forbidden.title');
  message = input('forbidden.message');
}
